import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration
// Replace these with your actual Firebase project credentials
export const firebaseConfig = {
  apiKey: "AIzaSyBkeZywNE4yhysJn5QtB3WkoLq03AbSKJM",
  authDomain: "jackbot-2702d.firebaseapp.com",
  projectId: "jackbot-2702d",
  storageBucket: "jackbot-2702d.firebasestorage.app",
  messagingSenderId: "360815046846",
  appId: "1:360815046846:web:bf12c3c5ad8b02bd09eeef"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app; 